import { bignumber, BigNumber, BigNumberish } from './mathjs';

export function adjustDecimals(
  input: BigNumberish,
  decimals: number,
): BigNumber {
  return bignumber(input).div(bignumber(10).pow(decimals));
}
